import { Stack } from "@carbon/react";
import { FC } from "react";
import { FormProvider } from "react-hook-form";

import { NumberInputFormField } from "src/components/Form/NumberInputFormField.tsx";
import { TextAreaFormField } from "src/components/Form/TextAreaFormField";
import { FraudTypeSinglePickerFormField } from "src/components/Pickers/FraudTypeSinglePickerFormField";
import { useT } from "src/internationalization";
import { AlertValidationDecision } from "src/types/alert";

import { FraudDetailsFormControl } from "./useFraudDetailsForm";

export type FraudDetailsFormProps = {
  fraudDetailsFormControl: FraudDetailsFormControl;
  decisionValue: AlertValidationDecision;
  caseAmount: string | null;
  onError?: () => void;
};

// TODO fix focus
export const FraudDetailsForm: FC<FraudDetailsFormProps> = ({
  fraudDetailsFormControl,
  decisionValue,
  caseAmount,
}) => {
  const t = useT();

  return (
    <FormProvider {...fraudDetailsFormControl.methods}>
      <Stack gap={5}>
        {(decisionValue === "fraudPrevented" ||
          decisionValue === "provenFraudWithFinancialLoss") && (
          <NumberInputFormField
            id="amount"
            label={
              decisionValue === "fraudPrevented"
                ? t("alerts.confirmFraud.details.form.amount.prevented.label")
                : t("alerts.confirmFraud.details.form.amount.suffered.label")
            }
            helperText={
              caseAmount
                ? t("alerts.confirmFraud.details.form.amount.helper", {
                    amount: caseAmount,
                  })
                : undefined
            }
            control={fraudDetailsFormControl.control}
            name="amount"
            min={0}
          />
        )}
        {"compliant" !== decisionValue && (
          <FraudTypeSinglePickerFormField
            name="fraudType"
            control={fraudDetailsFormControl.control}
            label={t("alerts.confirmFraud.details.form.fraudType.label")}
          />
        )}
        <TextAreaFormField
          id="comment"
          label={t("general.form.comment.label")}
          helperText={t("alerts.confirmFraud.details.form.comment.helper")}
          control={fraudDetailsFormControl.control}
          name="comment"
        />
      </Stack>
    </FormProvider>
  );
};
